export default "__VITE_ASSET__CpbXbrJM__"